import { render, staticRenderFns } from "./RegularReservationFormCard.vue?vue&type=template&id=67184600&scoped=true&"
import script from "./RegularReservationFormCard.vue?vue&type=script&lang=js&"
export * from "./RegularReservationFormCard.vue?vue&type=script&lang=js&"
import style0 from "./RegularReservationFormCard.vue?vue&type=style&index=0&id=67184600&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67184600",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
